import Axios from "axios";
var PurchaseOrderForUpperSupService = (function () {
    function PurchaseOrderForUpperSupService() {
    }
    PurchaseOrderForUpperSupService.prototype.getList = function (params) {
        return Axios.get("supplierclientapi/upper_purchase_order/list", { params: params });
    };
    PurchaseOrderForUpperSupService.prototype.getGoodsListLimit = function (params) {
        return Axios.get("supplierclientapi/upper_purchase_order/list_goods", { params: params });
    };
    PurchaseOrderForUpperSupService.prototype.getGoodsList = function (params) {
        return Axios.get("supplierclientapi/supplieruppergoods/supplier_goods_list", { params: params });
    };
    PurchaseOrderForUpperSupService.prototype.addOrder = function (params) {
        return Axios.post("supplierclientapi/upper_purchase_order/save", params);
    };
    PurchaseOrderForUpperSupService.prototype.getDetail = function (params) {
        return Axios.get("supplierclientapi/upper_purchase_order/detail", { params: params });
    };
    PurchaseOrderForUpperSupService.prototype.audit = function (params) {
        return Axios.post("supplierclientapi/upper_purchase_order/audit", params);
    };
    PurchaseOrderForUpperSupService.prototype.discard = function (params) {
        return Axios.post("supplierclientapi/upper_purchase_order/cancel", params);
    };
    PurchaseOrderForUpperSupService.prototype.sendEmail = function (params) {
        return Axios.post("supplierclientapi/upper_purchase_order/send_email", params);
    };
    PurchaseOrderForUpperSupService.prototype.getSupplierupperOptions = function (params) {
        return Axios.get("supplierclientapi/supplierupper/get_options", { params: params });
    };
    PurchaseOrderForUpperSupService.prototype.getAccountOptions = function (params) {
        return Axios.get("supplierclientapi/account/get_options", { params: params });
    };
    PurchaseOrderForUpperSupService.prototype.getSupplierorganOptions = function (params) {
        return Axios.get("supplierclientapi/supplierorgan/get_options", { params: params });
    };
    PurchaseOrderForUpperSupService.prototype.getSupplierdepotOptions = function (params) {
        return Axios.get("supplierclientapi/supplierdepot/get_options", { params: params });
    };
    PurchaseOrderForUpperSupService.createInstance = function () {
        PurchaseOrderForUpperSupService.getInstance();
    };
    PurchaseOrderForUpperSupService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return PurchaseOrderForUpperSupService;
}());
export default PurchaseOrderForUpperSupService;
